import { Path, generatePath } from "react-router-dom";
import type { AppRouteObject } from "../routes";
import { lazy } from "react";

export type UserOldListParams = { realm?: string; providerId: string };

const UserOldList = lazy(() => import("./UserOldList"));

const UserOldListRoute: AppRouteObject = {
  path: "/:realm?/user-old",
  element: <UserOldList />,
  breadcrumb: (t) => t("user-old"),
  handle: {
    access: 'view-user-old' as any,
  },
};

const routes: AppRouteObject[] = [
  UserOldListRoute,
];

export const toPage = (params: UserOldListParams): Partial<Path> => ({
  pathname: generatePath(UserOldListRoute.path, params),
});

export default routes;
